import React, { useState } from 'react'
import './ModalAddWaitlist.scss'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import { createWaitlistRecord } from '../../../../../../../../../crud/clients_api/client_waitlist'
import { ClientWaitlist } from '../../../../../types'
import { toast } from 'react-toastify';
import { X } from 'react-bootstrap-icons'
import { FaUserGroup } from 'react-icons/fa6'
import Dropdown from 'react-bootstrap/Dropdown';

interface ModalAddWaitlistProps {
  show: boolean;
  onHide: () => void;
  onSuccess?: (newWaitlist: ClientWaitlist) => void;
  setWaitList?: (waitList: ClientWaitlist[]) => void;
  waitList?: ClientWaitlist[];
  getClientWaitlistByLocalId?: (localId: number) => Promise<any>;
  localId?: number;
}

const ModalAddWaitlist: React.FC<ModalAddWaitlistProps> = ({ show, onHide, onSuccess, setWaitList, waitList, getClientWaitlistByLocalId, localId }) => {
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [people, setPeople] = useState(1);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const usedLocalId = localId ?? user?.local_id ?? 0;
    try {
      const payload = {
        local_id: usedLocalId,
        name,
        phone,
        people: Number(people)
      };
      const response = await createWaitlistRecord(payload);
      if (response && (response.data || response.waitlist_id)) {
        const newWaitlist = response.data || response;
        if (getClientWaitlistByLocalId && setWaitList) {
          // Refresca la lista completa desde el backend
          const updated = await getClientWaitlistByLocalId(usedLocalId);
          setWaitList(updated);
        } else if (setWaitList && waitList) {
          setWaitList([...waitList, newWaitlist]);
        }
        if (onSuccess) onSuccess(newWaitlist);
        toast.success('Agregado correctamente a la lista de espera');
        onHide();
      } else {
        setError('No se pudo crear el registro.');
        toast.error('No se pudo crear el registro.');
      }
    } catch (err) {
      setError('Error al crear el registro.');
      toast.error('Error al crear el registro.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered className='modal-add-waitlist' fullscreen="sm-down">
      <Modal.Header>
      <div className="form-modal-title-container">
        <Modal.Title className="form-modal-title">Agregar a la lista de espera</Modal.Title>
      </div>
      <Button variant="none" className="modal-close-button" onClick={onHide}>
        <X size={24} />
      </Button>
      </Modal.Header>
      <form onSubmit={handleSubmit}>
        <Modal.Body>
          <div className="mb-3">
            <input
              type="text"
              className="form-waitlist-control"
              value={name}
              onChange={e => setName(e.target.value)}
              required
              placeholder="Nombre"
            />
          </div>
          <div className="mb-3">
            <input
              type="text"
              className="form-waitlist-control"
              value={phone}
              onChange={e => setPhone(e.target.value)}
              placeholder="Teléfono"
            />
          </div>
          <div className="mb-3 people-dropdown">
            <label><FaUserGroup /> Personas</label>
            <Dropdown align="end">
              <Dropdown.Toggle variant='none' className='mp-button light' size="sm">{people}</Dropdown.Toggle>
              <Dropdown.Menu>
                {[...Array(10)].map((_, i) => (
                  <Dropdown.Item key={i+1} onClick={() => setPeople(i+1)}>
                    {i+1}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          </div>
          {error && <div className="alert alert-danger">{error}</div>}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" className='form-button-cancel' onClick={onHide} disabled={loading}>
            Cancelar
          </Button>
          <Button variant="primary" className='form-button-create' type="submit" disabled={loading}>
            {loading ? 'Guardando...' : 'Agregar'}
          </Button>
        </Modal.Footer>
      </form>
    </Modal>
  );
};

export default ModalAddWaitlist;